import { render, staticRenderFns } from "./adminCustomerIdDetail.vue?vue&type=template&id=432196ea&"
import script from "./adminCustomerIdDetail.vue?vue&type=script&lang=ts&"
export * from "./adminCustomerIdDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports